/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { isIntegerDependencies } from './dependenciesIsInteger.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createApply } from '../../factoriesAny.js';
export var applyDependencies = {
  isIntegerDependencies: isIntegerDependencies,
  typedDependencies: typedDependencies,
  createApply: createApply
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesApply.generated.js
// module id = 317
// module chunks = 0